import useAuthentication from "../../hooks/useAuthentication";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { HOME } from "../../shared/lib/routesResolver";
import LeftSide from "./LeftSide";
import RightSide from "./RightSide";

const PublicLayout = () => {
  const auth = useAuthentication();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLogged()) {
      navigate(HOME);
    }
  }, []);

  return (
    <div className="w-full min-h-screen max-h-screen">
      <div className="flex flex-row w-full min-h-screen max-h-screen">
        <LeftSide />
        <RightSide />
      </div>
    </div>
  );
};

export default PublicLayout;
